import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonWorkerPoolOverview, CommonWorkerPoolTopics } from "../../CommonComponents/CommonWorkerPoolViews";

export const InfrastructureWorkerPoolRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.infrastructure.workerPool,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonWorkerPoolOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonWorkerPoolTopics />;
    },
};
